import { ReactNode, useState } from 'react';
import {
  useControlPostDetailsModal,
  ControlPostDetailsModalType,
  UseControlPostDetailsModalProps
} from '@anytag/shared-hooks';
import { CarouselModal, CarouselModalProps } from '../../../carousel-modal';
import { PostModalContext } from './post-modal-context';

export interface UncontrolledModalProps<T extends ControlPostDetailsModalType = ControlPostDetailsModalType>
  extends Omit<CarouselModalProps, 'open' | 'onClose' | 'children'>,
    UseControlPostDetailsModalProps<T> {
  children: ReactNode | ((props: { selectedPost: T; closeModal: () => void }) => ReactNode);
}

export const UncontrolledModal = <T extends ControlPostDetailsModalType>({
  posts,
  children,
  paramKey,
  size = 'lg',
  ...restProps
}: UncontrolledModalProps<T>) => {
  const [modalSize, setModalSize] = useState<CarouselModalProps['size'] | null>(size); // set null to use default size
  const { selectedPost, siblingPostId, closePost, handleClickNext, handleClickPrev } = useControlPostDetailsModal<T>({
    posts,
    paramKey
  });

  return posts.length && !!selectedPost ? (
    <PostModalContext value={{ selectedPost, setModalSize, closeModal: closePost }}>
      <CarouselModal
        size={modalSize || size}
        onClose={closePost}
        open={!!selectedPost}
        onClickNext={handleClickNext}
        onClickPrev={handleClickPrev}
        siblingPostId={siblingPostId}
        {...restProps}
      >
        {selectedPost
          ? typeof children === 'function'
            ? children({ selectedPost, closeModal: closePost })
            : children
          : null}
      </CarouselModal>
    </PostModalContext>
  ) : null;
};
